module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a-entity', {
    attrs: {
      "position": _vm.attributify(_vm.position)
    }
  }, [_c('a-entity', {
    attrs: {
      "obj-model": "obj: #frame-obj;",
      "scale": "2 2 2",
      "position": "0 6 0",
      "rotation": _vm.attributify(_vm.rotation),
      "material": "shader: standard; color: #60ffec; side: double;"
    }
  }), _vm._v(" "), _c('a-entity', {
    attrs: {
      "obj-model": "obj: #frame-obj;",
      "scale": "2 2 2",
      "position": "0 -6 0",
      "rotation": _vm.attributify(_vm.rotation),
      "material": "shader: standard; color: #60ffec; side: double;"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-d829b3f4!./~/vue-loader/lib/selector.js?type=template&index=0!./client/components/Frame.vue
// module id = 187
// module chunks = 2